import React, { useContext, useEffect, useState } from 'react';
import { useHits, useInstantSearch } from 'react-instantsearch-hooks-web';
import appContext from '../../Context/appContext';
import { ASAP, SCHEDULE } from '../../constants/deliveryType';
import { RESULT_FOUND, RESULT_NOT_FOUND, RESULT_TYPO_TOLERENCE } from '../../constants/search';
import { getHighlightedWord } from '../../helpers/search';
import { useDeliveryDetails } from '../../hooks/app';
import InlineLoader from '../InlineLoader';
import { useDispatch, useSelector } from 'react-redux';
import { setResultState } from '../../redux/slices/searchSlice';

const SearchStats = ({ currentTab, setTab, initialDeliveryAddressDetails, setListLoading, listLoading }) => {
  const { results } = useHits();
  const { status } = useInstantSearch();
  const {
    data: { asapEnabled, scheduleEnabled }
  } = useDeliveryDetails(initialDeliveryAddressDetails);

  const [productAvailablity, setProductAvailablity] = useState('');
  const { hits, nbHits, query } = results || {};
  // const {
  //   // state: {
  //   //   search: {
  //   //     searchQuery,
  //   //     searchProductCount: { asapCount, scheduleCount }
  //   //   }
  //   // },
  //   dispatch
  // } = useContext(appContext);
  const { searchQuery, searchProductCount: { asapCount, scheduleCount } = {} } = useSelector(state => state.search)
  const dispatchRedux = useDispatch()

  const { typoTolerance, highlightedText = '' } = getHighlightedWord(hits?.[0]?._highlightResult || {}, query);

  useEffect(() => {
    if (!query) {
      setListLoading(true);
    }
    else {
      setListLoading(false);
    }
  }, [query])

  useEffect(() => {
    const searchResultType = nbHits && !typoTolerance ? RESULT_FOUND : nbHits && typoTolerance ? RESULT_TYPO_TOLERENCE : RESULT_NOT_FOUND;
    // dispatch({ type: 'setResultState', payload: searchResultType });
    dispatchRedux(setResultState(searchResultType))
  }, [nbHits, typoTolerance, status])

  useEffect(() => {
    if (currentTab == SCHEDULE && asapCount > 0 && scheduleCount == 0 && asapEnabled) {
      setTab(ASAP);
      setProductAvailablity('Super Fast Delivery');
    } else if (currentTab == ASAP && asapCount == 0 && scheduleCount > 0 && scheduleEnabled) {
      setTab(SCHEDULE);
      setProductAvailablity('Scheduled Delivery');
    }
  }, [asapCount, scheduleCount]);

  return (
    listLoading ?
      <div className="text-center my-3">
        <InlineLoader positionRelative className="big" />
      </div> :
      <div className="search-stats">
        {nbHits && (!typoTolerance || searchQuery.length < 4) ? (
          <p className="show-results">
            <span>{`Showing results for `}</span>
            <span className="text-primary bold">{`"${searchQuery}" `}</span>
            {productAvailablity ? (
              <>
                {' '}
                {'in '}
                {' '}
                <span className="text-primary bold"> {`${productAvailablity} `}</span>{' '}
              </>
            ) : (
              ''
            )}
            <span className="bold">{`(${nbHits.toLocaleString()})`}</span>
          </p>
        ) : nbHits && typoTolerance ? (
          <>
            <p className="search-no-match mb-0">{`We couldn't find a match for `}<b>{`"${searchQuery}"`}</b></p>
            <p className="show-results">
              <span>{`Showing results for `} <b>"</b></span>
              <span className="text-primary bold">{`${highlightedText}`}</span>
              {productAvailablity ? (
                <>
                  {' '}
                  {'in '}
                  {' '}
                  <span className="text-primary bold"> {`${productAvailablity} `}</span>
                </>
              ) : (
                ''
              )}
              <span>{`" and similar terms `}</span>
              <span className="bold">{`(${nbHits.toLocaleString()})`}</span>
            </p>
          </>
        ) : query ? (
          <>
            <p className="search-no-match mb-0">
              {`We couldn't find a match for `}
              <b>{`"${query}"`}</b>
            </p>
            <p className="semi-bold">{`The product you're searching for, may be discontinued or not available on our site yet.`}</p>
          </>
        ) : null}
      </div>
  );
};

export default SearchStats;
